import {boundMethod} from "autobind-decorator";
import {parseISO} from "date-fns";
import React from "react";
import {IntlContext, IntlShape} from "react-intl";
import {Link} from "react-router-dom";

import {EDocumentTypes} from "@/components/project/models";
import {EDocIdPrefixes} from "@/components/project/search/models";
import display from "@/services/display-name";
import http from "@/services/http";
import {ERoles} from "@/services/models";
import networkDevices from "@/services/network-devices";
import session from "@/services/session";
import {IQueuedSopModel} from "./models";

import {getDocIdInfo} from "@/components/project/search/doc-type";
import UserLink from "@toolbox/building-blocks/UserLink";
import DeleteButton from "@toolbox/button-like/DeleteButton";
import LockedTableCell from "@toolbox/design/LockedTableCell";
import Time from "@toolbox/design/Time";
import T from "@translate/T";

interface ISopInfoProps {
    isDragging: boolean;
    sop: IQueuedSopModel;
}

class SopInfo extends React.PureComponent<ISopInfoProps> {
    public static getQueueUrl(sop: IQueuedSopModel) {
        return getDocIdInfo(
            EDocIdPrefixes.CentSopQueues + "/" + sop.id,
            sop.project,
        ).url;
    }

    public render() {
        const {sop, isDragging} = this.props;

        return (
            <React.Fragment>
                <LockedTableCell isDragOccurring={isDragging}>
                    <Link to={SopInfo.getQueueUrl(sop)}>{sop.sopName}</Link>
                    {this.renderBadge()}
                </LockedTableCell>
                <LockedTableCell isDragOccurring={isDragging}>
                    <IntlContext.Consumer children={this.renderDevice} />
                </LockedTableCell>
                <LockedTableCell isDragOccurring={isDragging}>
                    <Time value={parseISO(sop.created)} />
                </LockedTableCell>
                <LockedTableCell isDragOccurring={isDragging}>
                    <UserLink
                        username={sop.user.username}
                        displayName={display.getOnlyDefault(sop.user)}
                        documentType={EDocumentTypes.User}
                    />
                </LockedTableCell>
                {this.renderDeleteButton()}
            </React.Fragment>
        );
    }

    private renderBadge() {
        const {sop} = this.props;
        if (!sop!.lastRecipientDevice) {
            return null;
        }

        return (
            <span className="badge bg-dark text-white ml-2 my-auto">
                <T>Sent to </T> {sop.lastRecipientDevice}
            </span>
        );
    }

    private renderDeleteButton() {
        if (!session.hasRole(ERoles.Recorder)) {
            return null;
        }

        return (
            <td>
                <DeleteButton
                    id={`delete-${this.props.sop.id}`}
                    onDelete={this.removeSop}
                />
            </td>
        );
    }

    @boundMethod
    private renderDevice(intl: IntlShape) {
        return networkDevices.getDeviceName(intl, this.props.sop.device);
    }

    @boundMethod
    private async removeSop() {
        try {
            await http.delete(`/api/centrifuge/sop/queue/${this.props.sop.id}`);

            return true;
        } catch {
            return false;
        }
    }
}

export default SopInfo;
